/**
 * @file
 * Provide methods for filter functionality.
 *
 * Per default the filterbar only shows filters which fit in the available
 * space. The following method clones all available filters to a modal window
 * on click. Here we use once() to make sure the modal only gets build
 * once for logged-in users.
 */

(function ($, Drupal) {
  /**
   * Implement filterbar behavior
   */

  Drupal.behaviors.filterbar = {
    attach: function attach(context) {
      once('awFilterbar', '.js-filterbar-modal-trigger', context).forEach(function (currentElement) {
        currentElement.addEventListener('click', function () {
          const $filterForm = $('.js-filter-form').clone(false);

          // Show hidden dropdown elements and reset item classes
          $filterForm.find('.js-dropdown-target').addClass('is-visible-dropdown-target');
          $filterForm.find('.js-filter-item').removeClass().addClass('form-item js-filter-item');

          // We have to reset the 'once' state for Drupal attached behaviors so they can be reinitialised e.g. autocomplete
          $filterForm.find('[data-once]').each(function (index, element) {
            once.remove(element.getAttribute('data-once'), element);
          })

          // Show labels and normalize text inputs
          $filterForm.find('.label').removeClass('sr-only').addClass('label--static');
          $filterForm.find('.textfield__button').remove();

          // Remove undesired classes
          $filterForm.find('*').addBack().removeClass('filterbar__content filterbar__dropdown js-dropdown-target textfield--combined checkbox--inline radio--inline');

          // Prefix unique attributes
          $filterForm.find('*').addBack().each(function () {
            const currentId = $(this).attr('id');
            const currentFor = $(this).attr('for');
            const currentS2Id = $(this).attr('data-select2-id');

            if (currentId) {
              $(this).attr('id', 'modal-' + currentId);
            }
            if (currentFor) {
              $(this).attr('for', 'modal-' + currentFor);
            }
            if (currentS2Id) {
              $(this).attr('data-select2-id', 'modal-' + currentS2Id);
            }
          });

          // Create filter modal
          const $filterModal = $filterForm.createModal(Drupal.t('Filter results'));

          // Remove Select2 elements and reinitialize
          $filterForm.find('.select2').remove();
          $filterForm.find('.js-select-replace').select2({
            dropdownParent: $filterModal
          });
        });
      });
    }
  };
})(jQuery, Drupal);
